import styled from 'styled-components';

const Header = styled.h1`
  margin: 0;
  ${({ color }) => ('color:' + color + ';' )}
  padding-bottom: ${({ paddingBottom }) => paddingBottom };
  font-size: ${({ isBig }) => (isBig ? '5em' : '3em')};
  font-weight: ${({ theme }) => theme.font.regular};
`

export default Header;